import { useRef } from "react";
import { BsFillPersonFill } from "react-icons/bs";
import { IoLogoWhatsapp, IoLogoLinkedin, IoLogoGithub } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import { MdAlternateEmail } from "react-icons/md";
import { BsFillPinAngleFill } from "react-icons/bs";
import emailjs from "@emailjs/browser";
import image from "../../assets/mail.png";
import "./contact.css";

const Contact = () => {
   const form = useRef();

   const sendEmail = async (e) => {
      e.preventDefault();

      await emailjs.sendForm("service_tcisj8c", "template_1hj0eeg", form.current, "kqEeL6RxIkRkFdojn").then(
         (result) => {
            console.log(result.text);
         },
         (error) => {
            console.log(error.text);
         }
      );

      e.target.reset();
      localStorage.setItem("message", "true");
      window.location.assign("/");
   };

   return (
      <div className="contact my-5">
         <div className="container">
            <div className="row justify-content-center align-items-center">
               <div className="img-two my-4 col-4 col-sm-10 col-md-5 text-center">
                  <img src={image} className="img-fluid" alt="" />
                  <div className="mt-4 d-none d-md-flex">
                     <a
                        className="mx-2 col icon-send github text-decoration-none"
                        href="https://github.com/josuemedinaguerrero?tab=repositories"
                        target="_blank"
                        rel="noreferrer"
                     >
                        <IoLogoGithub />
                     </a>
                     <a
                        className="mx-2 col icon-send whatsapp text-decoration-none"
                        href="https://wa.me/5930991528005"
                        target="_blank"
                        rel="noreferrer"
                     >
                        <IoLogoWhatsapp />
                     </a>
                     <a
                        className="mx-2 col icon-send linkedin text-decoration-none"
                        href="https://www.linkedin.com/in/josu%C3%A9-alejandro-medina-guerrero-719a3b235/"
                        target="_blank"
                        rel="noreferrer"
                     >
                        <IoLogoLinkedin />
                     </a>
                     <a
                        className="mx-2 col icon-send email text-decoration-none"
                        href="mailto:josuemedina.032810@gmail.com"
                        target="_blank"
                        rel="noreferrer"
                     >
                        <MdEmail />
                     </a>
                  </div>
               </div>

               <div className="col-10 my-4 col-md-5">
                  <h4 className="text-center fw-bold">Get in touch</h4>

                  <form ref={form} onSubmit={sendEmail}>
                     <div className="input-group mb-3">
                        <span className="input-group-text" id="basic-addon1">
                           <BsFillPersonFill />
                        </span>
                        <input
                           type="text"
                           name="name"
                           className="form-control"
                           id="name"
                           placeholder="Name"
                           required
                        />
                     </div>

                     <div className="input-group mb-3">
                        <span className="input-group-text" id="basic-addon1">
                           <MdAlternateEmail />
                        </span>
                        <input
                           type="email"
                           name="email"
                           className="form-control"
                           id="email"
                           placeholder="name@example.com"
                           required
                        />
                     </div>

                     <div className="input-group mb-3">
                        <span className="input-group-text" id="dsds">
                           <BsFillPinAngleFill />
                        </span>
                        <input
                           type="text"
                           name="subject"
                           className="form-control"
                           id="subject"
                           placeholder="Subject"
                        />
                     </div>

                     <div className="mb-3">
                        <label htmlFor="message" className="text-secondary form-label">
                           Message
                        </label>
                        <textarea
                           required
                           className="form-control"
                           name="message"
                           id="message"
                           rows={3}
                        ></textarea>
                     </div>

                     <div className="text-center">
                        <button type="submit" className="rounded-pill btn btn-success px-5">
                           Submit
                        </button>
                     </div>
                  </form>
               </div>
            </div>
            <div className="row icon-cell my-5 d-md-none text-center">
               <a
                  className="col icon-send github text-decoration-none"
                  href="https://github.com/josuemedinaguerrero?tab=repositories"
                  target="_blank"
                  rel="noreferrer"
               >
                  <IoLogoGithub />
               </a>
               <a
                  className="col icon-send whatsapp text-decoration-none"
                  href="https://wa.me/5930991528005"
                  target="_blank"
                  rel="noreferrer"
               >
                  <IoLogoWhatsapp />
               </a>
               <a
                  className="col icon-send linkedin text-decoration-none"
                  href="https://www.linkedin.com/in/josu%C3%A9-alejandro-medina-guerrero-719a3b235/"
                  target="_blank"
                  rel="noreferrer"
               >
                  <IoLogoLinkedin />
               </a>
               <a
                  className="col icon-send email text-decoration-none"
                  href="mailto:josuemedina.032810@gmail.com"
                  target="_blank"
                  rel="noreferrer"
               >
                  <MdEmail />
               </a>
            </div>
         </div>
      </div>
   );
};

export default Contact;
